"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelNavigationBlock = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const PanelMenuItem_1 = require("./PanelMenuItem");
const components_1 = require("../../../components");
const SidePanelNavigationBlock = function (props) {
    const { icon, data, search, single, headerText, defaultOnClick } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !single ? (react_1.default.createElement(components_1.Grid, { className: "glx-py-6 glx-pl-6 glx-bold glx-default-text", flex: true, flexRow: true, vCenter: true, gap: 2 },
            react_1.default.createElement("div", null, icon ? (0, react_icons_1.getIcon)(icon)({}) : null),
            react_1.default.createElement("div", null, headerText))) : null,
        data.map((item) => (react_1.default.createElement(PanelMenuItem_1.PanelMenuItem, { key: item.key, item: item, search: search, defaultOnClick: defaultOnClick }))),
        !single ? react_1.default.createElement("hr", { className: "glx-mx-8" }) : null));
};
exports.SidePanelNavigationBlock = SidePanelNavigationBlock;
SidePanelNavigationBlock.defaultProps = {
    search: undefined,
    defaultOnClick: undefined,
    icon: undefined,
};
